import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, watch } from 'vue';

import useContext from '@/composables/useContext';

import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import Search from '@/components/search/Search.vue';
import { setCookieInformationScript } from '../functions/cookie.functions';


export default /*@__PURE__*/_defineComponent({
  __name: 'StandardLayout',
  setup(__props) {

const isMounted = ref(false);
const { channel } = useContext();
watch(channel, (newVal, _) => {
  if (newVal != undefined) {
    setCookieInformationScript(newVal.language);
  }
});

onMounted(async () => {
  isMounted.value = true;
});

return (_ctx: any,_cache: any) => {
  const _component_router_page = _resolveComponent("router-page")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SiteHeader),
    (isMounted.value)
      ? (_openBlock(), _createBlock(Search, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_page),
    _createVNode(SiteFooter)
  ], 64))
}
}

})